// extracted by mini-css-extract-plugin
module.exports = {"colored":"Template_colored__1kQ27","linklist":"Template_linklist__28hAG","left_element":"Template_left_element__1-uAa"};